const plans = [
  {
    name: 'Free',
    limit: 7,
    price: 0,
    flashDiscount: 0,
    label: 'free',
    type: 'free',
    group: 'free',
    billingCycle: 'free',
    gaEcommerceProductId: 'free',
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },
  {
    name: 'Plus Monthly',
    limit: 200,
    price: 15,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-monthly-24122019',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly-24122019',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Plus Yearly',
    limit: 200,
    price: 60,
    flashDiscount: 0,
    label: 'plus',
    oldPlan: 24122019,
    type: 'plus-yearly-24122019',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 5.00,
    gaEcommerceProductId: 'plus-yearly-24122019',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Pro Monthly',
    limit: 10000,
    price: 36,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-monthly-24122019',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly-24122019',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Pro Yearly',
    limit: 10000,
    price: 144,
    flashDiscount: 0,
    label: 'pro',
    oldPlan: 24122019,
    type: 'pro-yearly-24122019',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 12,
    gaEcommerceProductId: 'pro-yearly-24122019',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Pro Monthly',
    limit: 10000,
    price: 59.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-monthly-10012020',
    group: 'pro',
    billingCycle: 'monthly',
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-monthly-10012020',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Pro Yearly',
    limit: 10000,
    price: 239.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-yearly-10012020',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 19.95,
    oldPlan: 10012020,
    gaEcommerceProductId: 'pro-yearly-10012020',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },

  // new plan 24122019
  {
    name: 'Essential Monthly',
    limit: 50,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: 'essential-monthly-07122022',
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'essential-monthly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Essential Yearly',
    limit: 50,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: 'essential-yearly-07122022',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: 'essential-yearly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },

  {
    name: 'Essential Monthly',
    limit: 50,
    price: 23.95,
    flashDiscount: 9,
    label: 'essential',
    type: 'essential-monthly',
    group: 'essential',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'essential-monthly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Essential Yearly',
    limit: 50,
    price: 95.40,
    flashDiscount: 36,
    label: 'essential',
    type: 'essential-yearly',
    group: 'essential',
    billingCycle: 'yearly',
    perMonth: 7.95,
    gaEcommerceProductId: 'essential-yearly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },

  {
    name: 'Plus Monthly',
    limit: 200,
    price: 32.95,
    flashDiscount: 0,
    label: 'plus',
    type: 'plus-monthly',
    group: 'plus',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'plus-monthly',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Plus Yearly',
    limit: 200,
    price: 131.40,
    flashDiscount: 0,
    label: 'plus',
    type: 'plus-yearly',
    group: 'plus',
    billingCycle: 'yearly',
    perMonth: 10.95,
    gaEcommerceProductId: 'plus-yearly',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Pro Monthly',
    limit: 10000,
    price: 49.95,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-monthly',
    group: 'pro',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'pro-monthly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Pro Yearly',
    limit: 10000,
    price: 191.40,
    flashDiscount: 0,
    label: 'pro',
    type: 'pro-yearly',
    group: 'pro',
    billingCycle: 'yearly',
    perMonth: 15.95,
    gaEcommerceProductId: 'pro-yearly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Edu (Small)',
    limit: 25,
    price: 4.95,
    flashDiscount: 0,
    label: 'edu (small)',
    type: 'edu-small',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-small',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu (Small)',
    limit: 25,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: 'edu-small-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-small-yearly-07122022',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu (Small)',
    limit: 25,
    price: 35.40,
    flashDiscount: 12,
    perMonth: 2.95,
    label: 'edu (small)',
    type: 'edu-small-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-small-yearly',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'Edu (Medium)',
    limit: 50,
    price: 9.95,
    flashDiscount: 0,
    label: 'edu (medium)',
    type: 'edu-medium',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-medium',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Edu (Medium)',
    limit: 50,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: 'edu-medium-yearly-07122022',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-medium-yearly-07122022',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Edu (Medium)',
    limit: 50,
    price: 65.40,
    flashDiscount: 24,
    perMonth: 5.45,
    label: 'edu (medium)',
    type: 'edu-medium-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-medium-yearly',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 23.95,
    flashDiscount: 0,
    label: 'edu (large)',
    type: 'edu-large',
    group: 'edu',
    billingCycle: 'monthly',
    gaEcommerceProductId: 'edu-large',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'Edu (Large)',
    limit: 200,
    price: 91.80,
    flashDiscount: 0,
    perMonth: 7.65,
    label: 'edu (large)',
    type: 'edu-large-yearly',
    group: 'edu',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'edu-large-yearly',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'One-Time (Mini)',
    limit: 15,
    price: 4.95,
    flashDiscount: 2,
    label: 'one-time (mini)',
    type: 'one-time-mini',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-mini',
    color1: 'bg-primary-90',
    color2: 'bg-primary-60',
  },
  {
    name: 'One-Time (Small)',
    limit: 30,
    price: 10.95,
    flashDiscount: 4,
    label: 'one-time (small)',
    type: 'one-time-small',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-small',
    color1: 'bg-yellow-50',
    color2: 'bg-yellow-10',
  },
  {
    name: 'One-Time (Medium)',
    limit: 100,
    price: 26.95,
    flashDiscount: 10,
    label: 'one-time (medium)',
    type: 'one-time-medium',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-medium',
    color1: 'bg-green-50',
    color2: 'bg-green-10',
  },
  {
    name: 'One-Time (Large)',
    limit: 1000,
    price: 35.95,
    flashDiscount: 0,
    label: 'one-time (large)',
    type: 'one-time-large',
    group: 'one-time',
    gaEcommerceProductId: 'one-time-large',
    color1: 'bg-purple-50',
    color2: 'bg-purple-10',
  },
  {
    name: 'White Label',
    limit: 10000,
    price: 395.00,
    flashDiscount: 0,
    label: 'white label',
    type: 'white-label',
    group: 'white-label',
    billingCycle: 'yearly',
    gaEcommerceProductId: 'white-label',
    color1: 'bg-secondary-50',
    color2: 'bg-secondary-15',
  },
]

export default {
  plans,

  getPlanByType(type) {
    const plan = plans.find((item) => item.type == type)

    return plan || null
  },

  typePayment: {
    createNewOneTime: 'create-new-one-time',
    createNewSubscrition: 'create-new-subscription',
    updateOneTime: 'update-one-time',
    updateSubscription: 'update-subscription',
    createNewSubscriptionRemoveOneTime: 'create-new-subscription-remove-one-time',
  },
}
